/**
 * Redux actions for the application.
 * @module redux/actions/luciPanel
 */

import { createAction } from 'redux-actions';
import DataEngine from '../../public/js/de';

const host = window.location.hostname;
const bucket = 'bn.camio.lucipanels';
const dataEngine = window.location.protocol === 'https:' ?
  new DataEngine({ host, path: 'dataengine/', bucket }) :
  new DataEngine({ host, port: 4300, bucket });

export const REQUEST_PANEL = 'LUCI_PANEL/REQUEST_PANEL';
export const REQUEST_PANEL_FAILED = 'LUCI_PANEL/REQUEST_PANEL_FAILED';
export const RECEIVED_PANEL = 'LUCI_PANEL/RECEIVED_PANEL';

export const getLuciPanel = (templateId) => async (dispatch) => {
  dispatch(createAction(REQUEST_PANEL)());
  try {
    const panel = await dataEngine.read(templateId);
    dispatch(createAction(RECEIVED_PANEL)({
      panel
    }));
  } catch (exception) {
    dispatch(createAction(RECEIVED_PANEL)({
      panel: null
    }));
  }
};

export const actions = {
  getLuciPanel
};



// WEBPACK FOOTER //
// ./app/actions/luciPanel.js